import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import createCache from '@emotion/cache'

export const createEmotionCache = () => {
    return createCache({ key: 'css', prepend: true })
}

let theme = createTheme({
    components: {
        MuiTextField: {
            variants: [
                {
                    props: { variant: 'outlined', color: 'info' },
                    style: {
                        input: {
                            color: `#0A131E`,
                        },
                    },
                },
            ],
        },
        MuiTypography: {
            defaultProps: {
                variantMapping: {
                    subtitle1: 'p',
                    subtitle2: 'p',
                },
            },
        },
    },
    palette: {
        mode: 'dark',
        action: {
            disabledBackground: '#AAAAAA',
            disabled: '#454754',
        },
        common: {
            black: '#0A131E',
        },
        primary: {
            main: '#D4E867',
            light: '#d4e86710',
            dark: '#d4e86780',
        },
        secondary: {
            main: '#1DAEFF',
            light: '#1DAEFF30',
        },
        info: {
            main: '#29b6f6',
            light: '#4fc3f7',
            dark: '#0288d1',
            contrastText: 'rbga(0,0,0,0.87)',
        },
        error: {
            main: '#dd4545',
            light: '#e06c6c',
        },
        background: {
            default: '#0A131E',
            paper: '#0A131E',
        },
        text: {
            primary: '#F6F6F6',
            secondary: '#9698A5',
        },
        gold: {
            main: '#ecd37c',
            light: '#ecd37c20',
            dark: '#ecd37c80',
        },
        // divider: '#454754',
    },
    shape: {
        borderRadius: 6,
    },
    typography: (palette) => ({
        fontFamily: 'Lexend',
        h1: {
            // fontSize: '2.75rem',
            fontWeight: 600,
        },
        h2: {
            // fontSize: '2.5rem',
            fontWeight: 700,
        },
        h3: {
            // fontSize: '2rem',
            fontWeight: 700,
        },
        h4: {
            // fontSize: '1.75rem',
            fontWeight: 700,
        },
        h5: {
            fontSize: '1.5rem',
            fontWeight: 700,
        },
        h6: {
            fontSize: '1.15rem',
            fontWeight: 700,
            lineHeight: 1.3,
        },
        subtitle1: {
            color: palette.text.secondary,
            lineHeight: 1.5,
        },
        subtitle2: {
            color: palette.text.secondary,
            lineHeight: 1.5,
        },
        body1: {
            // fontSize: '1rem',
            // lineHeight: 1.5,
        },
        body2: {
            // fontSize: '0.9rem',
        },
        button: {
            // fontSize: '1rem',
            // lineHeight: 1.5,
        },
    }),
    mixins: {
        toolbar: {
            minHeight: '60px',
        },
    },
})

theme = responsiveFontSizes(theme)

export default theme

export type Theme = typeof theme
